module.exports = __webpack_public_path__ + "img/12_13.09322e1f.png";